module.exports = __webpack_public_path__ + "static/media/fir_haz_lev.eebf0775.png";